import {
  legacy_createStore as createStore,
  compose,
  combineReducers,
  applyMiddleware,
} from "redux";

import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import thunk from "redux-thunk";
import { authReducer } from "./Reducers/AuthReducer";
import { chatReducer } from "./Reducers/ChatReducer";
import { dashboardReducer } from "./Reducers/DashboardReducer";
import { callReducer } from "./Reducers/CallReducer";
import { contactReducer } from "./Reducers/ContactReducer";
import { outboundReducer } from "./Reducers/OutboundReducer";
import { ticketReducer } from "./Reducers/TicketReducer";
import { agentReducer } from "./Reducers/AgentReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  chat: chatReducer,
  dashboard: dashboardReducer,
  call: callReducer,
  contact: contactReducer,
  outbound: outboundReducer,
  ticket: ticketReducer,
  agent: agentReducer,
});

/* Previous configuration */
// const middleware = [thunk];
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(
// 	rootReducer,
// 	composeEnhancers(applyMiddleware(...middleware))
// );

// export default store;

/* New configuration with redux-persist */
const persistConfig = {
  key: "root",
  storage: storageSession,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const middleware = [thunk];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

let persistor = persistStore(store);
export { persistor, store };
